import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "id"]

import type { HTMLAttributes } from 'vue'
import { useVModel } from '@vueuse/core'
import { cn } from '@/lib/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
    defaultValue: {},
    modelValue: {},
    class: {},
    name: {},
    id: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
})

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    name: _ctx.name,
    id: _ctx.id,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modelValue) ? (modelValue).value = $event : null)),
    class: _normalizeClass(_unref(cn)('flex h-10 w-full rounded-xl border border-gray-200 bg-background px-3 py-2 text-xs font-semibold ring-offset-background file:border-0 file:bg-transparent file:text-xs file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus:opacity-100 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50', props.class))
  }, null, 10, _hoisted_1)), [
    [_vModelText, _unref(modelValue)]
  ])
}
}

})